import { MonthlyCalendarContainer, AdminCalendar } from '../Calendar'
import { Users, AddUserAccount } from '../UserManagement'
import { Logistics } from '../CaseWorklist/Logistics'
import { InboxPage } from '../CaseWorklist/Pathologist'
import { LabManager } from '../CaseWorklist/LabManager'
import { ITAdmin } from '../CaseWorklist/ITAdmin'
import { ITAdminSettings } from '../Settings/Settings'
import { Reporting } from '../Reports'
import { SearchTRFInput } from './../HOC/SearchTRFInput'
import Summary from '../CaseDiagnosis/DiagnosisSummary/Summary'

export const userRoutes = {
  NL_Pathologist: [
    {
      path: '/case-worklist',
      component: InboxPage,
      exact: true,
    },
    {
      path: '/search',
      component: SearchTRFInput,
      exact: true,
    },
    {
      path: '/calendar',
      component: MonthlyCalendarContainer,
      exact: true,
    },
    {
      path: '/diagnosis-summary',
      component: Summary,
      exact: true,
    },
    {
      path: '/*',
      component: InboxPage,
      exact: true,
    },
  ],
  NL_LabManager: [
    {
      path: '/case-worklist',
      component: InboxPage,
      exact: true,
    },
    {
      path: '/search',
      component: SearchTRFInput,
      exact: true,
    },
    {
      path: '/reporting',
      component: InboxPage,
      exact: true,
    },
    {
      path: '/manager-options',
      component: Users,
      exact: true,
    },
    {
      path: '/admin-calendar',
      component: AdminCalendar,
      exact: true,
    },
    {
      path: '/lab-manager',
      component: LabManager,
      exact: true,
    },
    {
      path: '/load-reports',
      component: Reporting,
      exact: true,
    },
    {
      path: '/*',
      component: LabManager,
      exact: true,
    },
  ],
  NL_WOMA_ADMIN: [
    {
      path: '/reporting',
      component: ITAdmin,
      exact: true,
    },
    {
      path: '/search',
      component: SearchTRFInput,
      exact: true,
    },
    {
      path: '/manager-options',
      component: Users,
      exact: true,
    },
    {
      path: '/manager-options/add-user-account',
      component: AddUserAccount,
      exact: true,
    },
    {
      path: '/admin-calendar',
      component: AdminCalendar,
      exact: true,
    },
    {
      path: '/load-reports',
      component: Reporting,
      exact: true,
    },
    {
      path: '/it-admin',
      component: ITAdmin,
      exact: true,
    },
    {
      path: '/settings',
      component: ITAdminSettings,
      exact: true,
    },
    {
      path: '/*',
      component: ITAdmin,
      exact: true,
    },
  ],
  NL_SpecimenLogistics: [
    {
      path: '/logistics',
      component: Logistics,
      exact: true,
    },
    {
      path: '/search',
      component: SearchTRFInput,
      exact: true,
    },
    {
      path: '/admin-calendar',
      component: AdminCalendar,
      exact: true,
    },
    {
      path: '/manager-options',
      component: Users,
      exact: true,
    },
    {
      path: '/manager-options/add-user-account',
      component: AddUserAccount,
      exact: true,
    },
    {
      path: '/load-reports',
      component: Reporting,
      exact: true,
    },
    {
      path: '/*',
      component: Logistics,
      exact: true,
    },
  ],
}
